import verificationStatuses from '../constants/verificationStatuses';

export const getIsVerified = acc =>
  acc && acc.idTokenClaims.verificationStatus === verificationStatuses.VERIFIED;
